// Version : 0.0.1
// Author : VISHNU
//Last ADD : add update code not working changes changes for alignment unwanted code remove response handle changes for alignement input '
// MODFIED DATA : 06-08-2025

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL, FIN_API_URL } from '../../../const';

/*********** FETCH PARTICULAR LOAN INDEX START ************************ */
export const fetchParticularLoanIndexDetails = (fetchData: any) => {
	const data = {
		getParticularLoanIndexDetailsDataToken: fetchData,
	};
	const url = `${API_URL}getParticularLoanIndexDetailsToken`;
	return makeApiCall(url, data);
};
/*********** FETCH PARTICULAR LOAN INDEX START ************************ */

/*********** DELETE PARTICULAR LOAN INDEX START ************************ */
export const deleteParticularLoanIndexDetails = (fetchData: any) => {
	const data = {
		DeleteParticularMemberInLoanIndexToken: fetchData,
	};
	const url = `${API_URL}deleteParticularMemberInLoanIndex`;
	return makeApiCall(url, data);
};
/*********** DELETE PARTICULAR LOAN INDEX END ************************ */

/*********** FETCH FINANCE ACCOUNT START ************************ */
export const fetchFinanceAccountsList = (fetchData: any) => {
	const data = {
		FinanceAccountsBasedonTypeDataToken: fetchData,
	};
	const url = `${API_URL}financeAccountsBasedonType`;
	return makeApiCall(url, data);
};
/*********** FETCH FINANCE ACCOUNT END ************************ */

/*********** FETCH LOAN SCHEDULE LIST START ************************ */
export const fetchLoanScheduleList = (fetchData: any) => {
	const data = {
		getLoanInfoBasedOnMembersBothclosedDataToken: fetchData,
	};
	const url = `${API_URL}getLoanInfoBasedOnMembersBothclosed`;
	return makeApiCall(url, data);
};
/*********** FETCH LOAN SCHEDULE LIST END ************************ */

/*********** UPDATE LOANINDEX FUNER START ************************ */
export const updateLoanIndexFunder = (fetchData: any) => {
	const data = {
		updateLoanIndexInvestorDataToken: fetchData,
	};
	const url = `${API_URL}updateLoanIndexInvestor`;
	return makeApiCall(url, data);
};
/*********** UPDATE LOANINDEX FUNER END ************************ */

/*********** UPDATE LOANINDEX MEETTIME START ************************ */
export const updateLoanIndexMeettime = (fetchData: any) => {
	const data = {
		updateLoanDisbursmentdateDataToken: fetchData,
	};
	const url = `${API_URL}updateLoanDisbursmentdate`;
	return makeApiCall(url, data);
};
/*********** UPDATE LOANINDEX MEETTIME END ************************ */

/*********** UPDATE LOANINDEX PUROSE  START ************************ */
export const updateLoanIndexPOL = (fetchData: any) => {
	const data = {
		updatePurposeLoanInvestorDataToken: fetchData,
	};
	const url = `${API_URL}updatePurposeLoanInvestor`;
	return makeApiCall(url, data);
};
/*********** UPDATE LOANINDEX PUROSE  END ************************ */

/*********** CREATE LOAN INDEX DISBURESEMENT START ************************ */
export const createLoanIndexDisbursement = (fetchData: any) => {
	const data = {
		createOnGoingProductLoanIndexDataToken: fetchData,
	};
	const url = `${API_URL}createOnGoingProductLoanIndex`;
	return makeApiCall(url, data);
};
/*********** CREATE LOAN INDEX DISBURESEMENT END ************************ */

/*********** CREATE TRANSACTION DISBURSMENT START ************************ */
export const createTransactionDisbursement = (fetchData: any) => {
	const data = {
		createDisbursementTranscationEntryDataToken: fetchData,
	};
	const url = `${FIN_API_URL}createDisbursementTranscationEntry`;
	return makeApiCall(url, data);
};
/*********** CREATE TRANSACTION DISBURSMENT END ************************ */

/*********** CREATE TRANSACTION ADDITIONAL CHARGES START ************************ */
export const createTransactionAdditionalCharges = (fetchData: any) => {
	const data = {
		createAdditionalAccountTranscationEntryDataToken: fetchData,
	};
	const url = `${FIN_API_URL}createAdditionalAccountTranscationEntry`;
	return makeApiCall(url, data);
};
/*********** CREATE TRANSACTION ADDITIONAL CHARGES END ************************ */

/*********** FETCH NEXT TRANSACTION SERIAL NO START ************************ */
export const fetchNextTransactionSerialNo = (fetchData: any) => {
	const data = {
		nextTransactionSerialNumberToken: fetchData,
	};
	const url = `${API_URL}getNextTransactionSerialNumber`;
	return makeApiCall(url, data);
};
/*********** FETCH NEXT TRANSACTION SERIAL NO END ************************ */

/*********** FETCH PRODUCT ACCOUNT DEATIL START ************************ */
export const fetchProductAccountDetails = (fetchData: any) => {
	const data = {
		productAccountDetailDataToken: fetchData,
	};
	const url = `${API_URL}productAccountDetail`;
	return makeApiCall(url, data);
};
/*********** FETCH PRODUCT ACCOUNT DEATIL END ************************ */

/*********** FETCH VOUCHER BASED ON COMPANY START ************************ */
export const fetchVoucherCountBasedOnCompany = (fetchData: any) => {
	const data = {
		getCompanyVoucherCountBasedOnCompanyToken: fetchData,
	};
	const url = `${FIN_API_URL}getVoucherCountBasedOnCompany`;
	return makeApiCall(url, data);
};
/*********** FETCH VOUCHER BASED ON COMPANY END ************************ */

/*********** FETCH INTER BRANCH CONTRA START ************************ */
export const fetchInterBranchContra = (fetchData: any) => {
	const data = {
		getInterBranchContraAccountDataToken: fetchData,
	};
	const url = `${FIN_API_URL}getInterBranchContraAccount`;
	return makeApiCall(url, data);
};
/*********** FETCH INTER BRANCH CONTRA END ************************ */

/*********** FETCH ALL PRODUCT ADDITIONAL ACCOUNT START ************************ */
export const fetchAllProductAdditionalAccount = (fetchData: any) => {
	const data = {
		getAllProductAdditionalAccountListDataToken: fetchData,
	};
	const url = `${FIN_API_URL}getAllProductAdditionalAccountList`;
	return makeApiCall(url, data);
};
/*********** FETCH ALL PRODUCT ADDITIONAL ACCOUNT END ************************ */

/*********** FETCH ALL RANGE PRODUCT START ************************ */
export const fetchAllRangeProduct = (fetchData: any) => {
	const data = {
		getFilterRangeProductListDataToken: fetchData,
	};
	const url = `${API_URL}getFilterRangeProductList`;
	return makeApiCall(url, data);
};

/*********** FETCH ALL RANGE PRODUCT START ************************ */

/*********** CREATE TOPUP LOAN INDEX START ************************ */
export const createTopupLoanIndex = (fetchData: any) => {
	const data = {
		createTopupLoanIndexDataToken: fetchData,
	};
	const url = `${API_URL}createTopupLoanIndex`;
	return makeApiCall(url, data);
};
/*********** CREATE TOPUP LOAN INDEX END ************************ */

/*********** FETCH INSTRUMENT START ************************ */
export const fetchInstructionDetails = (instructionData: any) => {
	const data = {
		GetAllInstrumentListToken: instructionData,
	};
	const url = `${API_URL}fetchInstrumentList`;
	return makeApiCall(url, data);
};
/*********** FETCH INSTRUMENT START ************************ */

/*********** GET INVESTOR DETAILS START ************************ */
export const getInvestorDetails = (investorData: any) => {
	const data = {
		getInvestorDetailsDataToken: investorData,
	};
	const url = `${API_URL}getAllInvestmentMadeList`;
	return makeApiCall(url, data);
};
/*********** GET INVESTOR DETAILS END ************************ */

/** *********************  START HDFC PAYOUT TRANSACTION  ******************** */
export const hdfcPayoutTransactionGet = (hdfcPayoutTransactionData: any) => {
	const data = {
		HDFCPayoutTransactionToken: hdfcPayoutTransactionData,
	};
	const url = `${API_URL}HdfcIntegrationPayment`;
	return makeApiCall(url, data);
};
/** *********************  END HDFC PAYOUT TRANSACTION ******************** */
